module.exports = __webpack_public_path__ + "img/hbao2.cbfe6216.png";